import JourneyCardSkeleton from '@/components/purchase/journey/JourneyCardSkeleton';
import JourneyList from '@/components/purchase/journey/JourneyList';
import { outboundOrInboundJourneysLoadingSelector } from '@/features/loading/loadingSelectors';
import { setSelectedInboundJourney } from '@/features/purchase/purchaseActions';
import { inboundDataSelector } from '@/features/purchase/purchaseSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { GTM_EVENT } from '@/utils/gtm';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const InboundJourneyList = () => {
  const navigate = useNavigate();
  const inboundData = useSelector(inboundDataSelector);
  const loading = useSelector(outboundOrInboundJourneysLoadingSelector);

  useEffect(() => {
    // If no journeys and not loading, redirect back to search
    // (Inbound journeys are fetched by OutboundJourneyList)
    if (!inboundData.journeys && !loading) {
      navigate('/purchase');
    }
  }, [inboundData.journeys, loading, navigate]);

  // Show skeleton while loading and no journeys yet
  if (loading && !inboundData.journeys) {
    return (
      <div className="pb-22 mx-auto w-full max-w-laptop p-4">
        <div className="mx-auto max-w-mobile">
          <div className="grid grid-cols-[1fr_auto] gap-y-4">
            {[1, 2, 3, 4].map((i) => (
              <JourneyCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <JourneyList
      {...inboundData}
      setSelectedJourney={setSelectedInboundJourney}
      onContinue={() => navigate('/purchase/inbound/offer')}
      journeySelectedEvent={GTM_EVENT.INBOUND_JOURNEY_SELECTED}
      title={
        inboundData.journeys && inboundData.journeys.length > 0 ? (
          <TransText i18nKey="selectReturnTrip" />
        ) : undefined
      }
      onGoBack={() => navigate(-1)}
    />
  );
};

export default InboundJourneyList;
